import { Component } from "react";
//import ReactMarkdown from 'react-markdown'
import "./blog-creator.css";
import PhotoSection from "./BlogSection/PhotoSection";

import Axios from "axios";
import { getRequestHeaders } from "../api";
import { baseUrl } from "../assets/Animations";
import LinkPopUp from "./LinkPopUp/LinkPopUp";
import QuizModule from "./QuizModule/QuizModule";
import StyleSelector from "./StyleSelector/StyleSelector";
import TypePopUp from "./TypePopUp/TypePopUp";

class BlogCreator extends Component {
  constructor(props) {
    super();
    this.state = {
      id: "",
      sections: [],
      author: "",
      school: "",
      date: "",
      googleTitle: "",
      googleMeta: "",
      articleImage: "",
      highlight: false,
      popupMarginLeft: null,
      popupMarginTop: null,
      editting: null,
      addLink: false,
      theField: null,
      currentSecion: null,
      saved: false,
      saving: false,
      initialized: false,
      submitted: false,
      wordCount: 0,
      areyousure: false,
      videoToRemove: null,
      error: false,
      metaLength: 160,
      loading: false,
      category: "mind",
      canonical: false,
      canonicalUrl: "",
      authorImageUrl: "",
    };
    let timeout = null;
  }

  componentDidMount = () => {
    document.addEventListener("click", this.clickHandle);
    document.addEventListener("keypress", this.checkHighlight);
    const setBlog = (blog) => {
      this.setState({
        id: blog.Preview.Id,
        wordCount: blog.Preview.WordCount,
        sections: blog.Article.Sections,
        date: blog.Preview.Date,
        googleTitle: blog.Preview.GoogleTitle,
        googleMeta: blog.Article.GoogleMeta,
        author: blog.Preview.Author,
        authorImageUrl: blog.Preview.AuthorImageUrl,
        metaLength: 160 - blog.Article.GoogleMeta.length,
        category: blog.Preview.Category ? blog.Preview.Category : "mind",
        canonical: blog.Article.Canonical,
        canonicalUrl: blog.Article.CanonicalUrl,
        school: blog.School,
        initialized: true,
      });
    };
    if (this.props.reviewing) {
      this.calculateWordCount(this.props.reviewing.Article.Sections);
      setBlog(this.props.reviewing);
    } else {
      let userName;
      if (this.props.userData.Name === "Prescott Blackler") {
        userName = "Gloria Conroy";
      } else if (this.props.userData.Name === "Danit Yeshaya") {
        userName = "Rosie Ziemann";
      } else {
        userName = this.props.userData.Name;
      }
      this.setState({
        id: Math.random().toString(16).slice(2),
        sections: [{ id: "blog-title", type: "title", content: "" }],
        author: userName,
        school: "",
        date: new Date(),
      });
      const blogId = window.location.pathname.split("blogtoreview/")[1];
      if (blogId) {
        this.setState({ loading: true });
        Axios.get(`${baseUrl}/blogstoreview`, getRequestHeaders())
          .then((res) => {
            const blog = res.data?.find((blog) => blog.Preview.Id === blogId);
            if (blog) {
              setBlog(blog);
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.setState({ loading: false });
          });
      }
    }
  };
  calculateWordCount = (sections) => {
    let totalWordCount = 0;
    for (let i = 0; i < sections.length; i++) {
      if (sections[i].type === "text") {
        if (sections[i].content) {
          totalWordCount =
            totalWordCount + sections[i].content.trim().split(/\s+/).length;
        }
      }
    }
    if (totalWordCount < 501) {
      document.getElementById("word-counter").style.color = "red";
    } else if (totalWordCount > 500 && totalWordCount < 2000) {
      document.getElementById("word-counter").style.color = "orange";
    } else {
      document.getElementById("word-counter").style.color = "green";
    }
    this.setState({
      wordCount: totalWordCount,
    });
  };
  clickHandle = (e) => {
    if (document.getSelection().type === "Range") {
      if (
        document.getElementById(e.target.id) &&
        e.target.id !== "blog-title"
      ) {
        let theField = document.getElementById(e.target.id);
        if (theField.selectionStart || theField.selectionStart === 0) {
          this.setState({
            sectionStart: theField.selectionStart,
            sectionEnd: theField.selectionEnd,
            highlight: e.target.id,
            currentSecion: e.target.id,
            popupMarginLeft: e.pageX,
            popupMarginTop: e.pageY,
            theField: null,
          });
        }
      }
    } else if (e.target.id === "create-link") {
      this.setState({
        addLink: this.state.currentSecion,
        highlight: false,
      });
    } else if (
      e.target.id === "flip-through-pull-quotes" ||
      e.target.id === "flip-through-pull-quotes-svg" ||
      e.target.id === "flip-through-pull-quotes-svg-path-1" ||
      e.target.id === "flip-through-pull-quotes-svg-path-2"
    ) {
      //LEAVE THE HIGHLIGHT WINDOW OPEN
    } else if (e.target.id !== "link-input-field") {
      this.setState({
        highlight: false,
        popupMarginLeft: null,
        popupMarginTop: null,
        addLink: null,
      });
    }
  };
  checkHighlight = () => {
    if (this.state.highlight) {
      this.setState({
        highlight: null,
      });
    }
    this.setState({
      saved: false,
    });
    clearTimeout(this.timeout);
    this.timeout = setTimeout(this.saveProgress, 3000);
    //TO REMOVE GREEN BOX AROUND VIDEO
    if (this.state.videoToRemove) {
      document.getElementById(this.state.videoToRemove).style.border = "none";
      this.setState({ videoToRemove: null });
    }
  };

  componentWillUnmount = () => {
    document.removeEventListener("click", this.clickHandle);
    document.removeEventListener("keypress", this.checkHighlight);
  };

  initializeBlog = () => {
    this.setState({
      saving: true,
    });
    let myToken = localStorage.getItem("token");
    let myHeader = {
      headers: { Authorization: `Bearer ${myToken}` },
    };
    Axios.post(
      `${baseUrl}/initblog`,
      {
        Id: this.state.id,
        Author: this.state.author,
        AuthorImageUrl: this.state.authorImageUrl,
        Date: this.state.date,
        GoogleTitle: this.state.googleTitle,
        Url: "",
        ArticleImage: "",
        Title: this.state.sections[0].content,
        GoogleMeta: this.state.googleMeta,
        Sections: this.state.sections,
        Category: this.state.category,
        Canonical: this.state.canonical,
        CanonicalUrl: this.state.canonicalUrl,
        School: this.state.school,
        Sections: this.state.sections,
      },
      myHeader
    )
      .then(() => {
        this.setState({
          saved: true,
          saving: false,
          initialized: true,
        });
      })
      .catch((err) => {
        this.setState({
          saving: false,
          saved: false,
        });
        console.log(err);
      });
  };

  insertAtCursor = (myValue, link) => {
    let myField = document.getElementById(this.state.highlight);
    //IE support
    if (myValue === "link") {
      //if (myField.selectionStart || myField.selectionStart === '0') {
      let myOtherField = document.getElementById(this.state.currentSecion);
      let startPos = this.state.sectionStart;
      let endPos = this.state.sectionEnd;
      let everything = myOtherField.value;
      let evePlus =
        everything.slice(0, startPos) + "[" + everything.slice(startPos);
      if (!link.startsWith("http")) {
        link = "http://" + link;
      }
      let eveAfter =
        evePlus.slice(0, endPos + `](${link})`.length) +
        `](${link})` +
        evePlus.slice(endPos + "]".length);
      myOtherField.value = eveAfter;
      let sections = this.state.sections;
      for (let i = 0; i < sections.length; i++) {
        if (sections[i].id === this.state.currentSecion) {
          sections[i].content = eveAfter;
          this.setState(
            {
              sections: sections,
              addLink: null,
            },
            () => {
              myOtherField.focus();
            }
          );
        }
      }
      //}
    } else {
      if (document.selection) {
        myField.focus();
        let sel = document.selection.createRange();
        sel.text = myValue;
      }
      //MOZILLA and others
      else if (myField.selectionStart || myField.selectionStart === 0) {
        if (myField.selectionStart === 0) {
          let endPos = myField.selectionEnd;
          let evePlus = `${myValue}${myField.value}`;
          let eveAfter =
            evePlus.slice(0, endPos + myValue.length) +
            myValue +
            evePlus.slice(endPos + myValue.length);
          myField.value = eveAfter;
        } else {
          let startPos = myField.selectionStart;
          let endPos = myField.selectionEnd;
          let everything = myField.value;
          let evePlus =
            everything.slice(0, startPos) +
            myValue +
            everything.slice(startPos);
          let eveAfter =
            evePlus.slice(0, endPos + myValue.length) +
            myValue +
            evePlus.slice(endPos + myValue.length);
          myField.value = eveAfter;
        }
        let sections = this.state.sections;
        for (let i = 0; i < sections.length; i++) {
          if (sections[i].id === this.state.highlight) {
            sections[i].content = myField.value;
            this.setState(
              {
                sections: sections,
              },
              () => {
                myField.focus();
              }
            );
          }
        }
      } else {
        myField.value += myValue;
      }
    }
  };

  addTheLink = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      this.insertAtCursor("link", e.target.value);
    }
  };

  handleKeyPress = (e) => {
    if (e.key === "Enter") {
      if (e.target.id === "blog-title" && this.props.reviewing === false) {
        if (this.state.initialized === false) {
          this.initializeBlog();
        }
        let sections = this.state.sections;
        let nextInput = {
          id: Math.random().toString(16).slice(2),
          type: "text",
          content: "",
          showPlus: true,
          popupOpen: false,
        };
        sections.splice(1, 0, nextInput);
        this.setState(
          {
            sections: sections,
            editting: nextInput.id,
          },
          () => {
            this.setCaretPosition(nextInput.id, 0);
          }
        );
        return;
      }
      let sectionIndex;
      let newSections = this.state.sections;

      let removed;
      let thePlus = true;
      let start = document.getElementById(e.target.id).selectionStart;
      let end = document.getElementById(e.target.id).value.length;
      if (start !== end) {
        removed = document.getElementById(e.target.id).value.slice(start, end);
        thePlus = false;
        let wholeString = document.getElementById(e.target.id).value;
        let sliced = wholeString.slice(0, start);
        for (let i = 0; i < newSections.length; i++) {
          if (newSections[i].id === e.target.id) {
            sectionIndex = i;
            newSections[i].content = sliced;
          }
        }
      }

      // THIS WAS AN EMERGENCY ADDITION IT SHOULD BE REFORMED
      else if (
        !/\s/g.test(e.target.value) &&
        (
          e.target.value.startsWith("https://www.mountainsidemusicacademy.com/chords") ||
        e.target.value.startsWith("https://www.lakesidemusicacademy.com/chords") ||
        e.target.value.startsWith("https://www.treesidemusicacademy.com/chords") ||
        e.target.value.startsWith("https://www.morningsidemusicacademy.com/chords") ||
        e.target.value.startsWith("https://www.parksidemusicacademy.com/chords") ||
        e.target.value.startsWith("https://www.atharomusic.com/chords")
      )
       ) {
        for (let i = 0; i < newSections.length; i++) {
          if (newSections[i].content === e.target.value) {
            newSections[i].type = "sheet-music";
            sectionIndex = i;
          }
        }
      }
      //----------------------------------------------------
      else if (
        !/\s/g.test(e.target.value) &&
        e.target.value.startsWith("http")
      ) {
        for (let i = 0; i < newSections.length; i++) {
          if (newSections[i].content === e.target.value) {
            newSections[i].type = "image";
            sectionIndex = i;
          }
        }
      } else {
        for (let i = 0; i < newSections.length; i++) {
          if (newSections[i].id === e.target.id) {
            sectionIndex = i;
          }
        }
        //sectionIndex = newSections.length
        removed = "";
      }
      let nextSection = {
        id: Math.random().toString(16).slice(2),
        type: "text",
        content: removed,
        showPlus: thePlus,
        popupOpen: false,
      };
      newSections.splice(sectionIndex + 1, 0, nextSection);
      this.setState(
        {
          sections: newSections,
          editting: nextSection.id,
        },
        () => {
          this.setCaretPosition(nextSection.id, 0);
        }
      );
    }
  };
  deleteFunc = (e) => {
    if (e.key === "Backspace" || e.key === "Delete") {
      let start = document.getElementById(e.target.id).selectionStart;
      let end = document.getElementById(e.target.id).selectionEnd;
      //let oldLength;
      if (start === 0 && start === end) {
        e.preventDefault();
        let allSections = this.state.sections;
        for (let i = 0; i < allSections.length; i++) {
          if (
            allSections[i].id === e.target.id &&
            allSections[i - 1].type === "text"
          ) {
            let oldLength = allSections[i - 1].content.length;
            allSections[i - 1].content = allSections[i - 1].content.concat(
              e.target.value
            );
            allSections.splice(i, 1);
            this.setState(
              {
                sections: allSections,
                editting: allSections[i - 1].id,
              },
              () => {
                this.setCaretPosition(allSections[i - 1].id, oldLength);
              }
            );
          } else if (
            allSections[i].id === e.target.id &&
            allSections[i - 1].type === "ellipse"
          ) {
            let theId = allSections[i - 1].id;
            allSections[i - 1].content = allSections[i].content;
            allSections[i - 1].type = "text";
            allSections[i - 1].showPlus = true;
            allSections[i - 1].popupOpen = false;
            allSections.splice(i, 1);
            this.setState(
              {
                sections: allSections,
                editting: theId,
              },
              () => {
                document.getElementById(theId).focus();
              }
            );
          } else if (
            allSections[i].id === e.target.id &&
            allSections[i - 1].type === "video"
          ) {
            if (!this.state.videoToRemove) {
              this.setState({
                videoToRemove: allSections[i - 1].id,
                sections: allSections,
              });
              document.getElementById(allSections[i - 1].id).style.border =
                "3px solid greenyellow";
            } else {
              let allSection = this.state.sections;
              let toRemove = i - 1;
              let theId = this.state.videoToRemove;
              for (let i = 0; i < allSection.length; i++) {
                if (allSection[i].id === this.state.videoToRemove) {
                  //theId = allSection[i].id
                  allSection[i].type = "text";
                  allSection[i].content = "";
                  allSection[i].showPlus = true;
                }
              }
              allSections.splice(toRemove, 1);
              this.setState({
                sections: allSection,
                editting: theId,
                videoToRemove: null,
              });
            }
          } else if (
            allSections[i].id === e.target.id &&
            allSections[i - 1].type === "affiliate"
          ) {
            if (!this.state.videoToRemove) {
              this.setState({
                videoToRemove: allSections[i - 1].id,
                sections: allSections,
              });
              document.getElementById(allSections[i - 1].id).style.border =
                "3px solid greenyellow";
            } else {
              let allSection = this.state.sections;
              let toRemove = i - 1;
              let theId = this.state.videoToRemove;
              for (let i = 0; i < allSection.length; i++) {
                if (allSection[i].id === this.state.videoToRemove) {
                  //theId = allSection[i].id
                  allSection[i].type = "text";
                  allSection[i].content = "";
                  allSection[i].showPlus = true;
                }
              }
              allSections.splice(toRemove, 1);
              this.setState({
                sections: allSection,
                editting: theId,
                videoToRemove: null,
              });
            }
          }
        }
      }
    } else if (e.key === "Enter") {
      e.preventDefault();
    }
    this.textAreaAdjust(document.getElementById(e.target.id));
  };

  setCaretPosition = (elemId, caretPos) => {
    let elem = document.getElementById(elemId);

    if (elem != null) {
      if (elem.createTextRange) {
        let range = elem.createTextRange();
        range.move("character", caretPos);
        range.select();
      } else {
        if (elem.selectionStart === 0) {
          elem.focus();
          elem.setSelectionRange(caretPos, caretPos);
        } else elem.focus();
      }
    }
  };

  textAreaAdjust = (element) => {
    element.style.height = "1px";
    element.style.height = 1 + element.scrollHeight + "px";
  };

  handleChange = (e, id) => {
    if (document.getElementById(e.target.id) && e.target.id !== "blog-title") {
      this.textAreaAdjust(document.getElementById(e.target.id));
    }
    let prevSections = this.state.sections;
    this.calculateWordCount(this.state.sections);
    for (let i = 0; i < prevSections.length; i++) {
      if (prevSections[i].id === id) {
        prevSections[i].content = e.target.value;
        e.target.value !== ""
          ? (prevSections[i].showPlus = false)
          : (prevSections[i].showPlus = true);
      }
    }
    this.setState({
      sections: prevSections,
    });
  };
  togglePopup = (id) => {
    let sections = this.state.sections;
    for (let i = 0; i < sections.length; i++) {
      if (sections[i].id === id) {
        if (sections[i].popupOpen) {
          sections[i].popupOpen = false;
          document.getElementById(`plus-${id}`).style.transform =
            "rotate(0deg)";
        } else {
          sections[i].popupOpen = true;
          document.getElementById(`plus-${id}`).style.transform =
            "rotate(45deg)";
        }
      }
    }
    this.setState({
      sections: sections,
    });
  };
  closePopup = (id) => {
    let sections = this.state.sections;
    for (let i = 0; i < sections.length; i++) {
      if (sections[i].id === id) {
        sections[i].popupOpen = false;
        if (document.getElementById(`plus-${id}`)) {
          document.getElementById(`plus-${id}`).style.transform =
            "rotate(0deg)";
        }
        sections[i].showPlus = false;
      }
    }
    this.setState({
      sections: sections,
    });
  };
  setSectionPhoto = (id) => {
    let sections = this.state.sections;
    for (let i = 0; i < sections.length; i++) {
      if (sections[i].id === id) {
        sections[i].type = "image";
        sections[i].popupOpen = false;
        sections[i].showPlus = false;
      }
    }
    this.setState({
      sections: sections,
    });
  };
  setSectionPullQuote = (id) => {
    let sections = this.state.sections;
    for (let i = 0; i < sections.length; i++) {
      if (sections[i].id === id) {
        if (sections[i].type === "text") {
          sections[i].type = "pullQuote1";
        } else if (sections[i].type === "pullQuote1") {
          sections[i].type = "pullQuote2";
        } else if (sections[i].type === "pullQuote2") {
          sections[i].type = "pullQuote3";
        } else if (sections[i].type === "pullQuote3") {
          sections[i].type = "text";
        }
      }
    }
    this.setState({
      sections: sections,
      highlight: id,
    });
  };
  setSectionAddVideo = (id) => {
    let sections = this.state.sections;
    for (let i = 0; i < sections.length; i++) {
      if (sections[i].id === id) {
        sections[i].type = "addVideo";
        sections[i].content = "";
        sections[i].popupOpen = false;
        sections[i].showPlus = false;
      }
    }
    setTimeout(() => {
      document.getElementById(id).focus();
    }, 10);
  };
  setSectionAffiliate = (id) => {
    let sections = this.state.sections;
    for (let i = 0; i < sections.length; i++) {
      if (sections[i].id === id) {
        sections[i].type = "addAffiliate";
        sections[i].content = "";
        sections[i].popupOpen = false;
        sections[i].showPlus = false;
      }
    }
    this.setState({
      sections: sections,
    });
  };
  submitAffiliateLink = (id) => {
    let sections = this.state.sections;
    let index;
    if (
      document.getElementById(`${id}-2`).value > 0 &&
      document.getElementById(`${id}-3`).value > 0
    ) {
      for (let i = 0; i < sections.length; i++) {
        if (sections[i].id === id) {
          index = i;
          sections[i].type = "affiliate";
          sections[i].content = document.getElementById(`${id}-1`).value;
          sections[i].width = document.getElementById(`${id}-2`).value;
          sections[i].height = document.getElementById(`${id}-3`).value;
          sections[i].popupOpen = false;
          sections[i].showPlus = false;
        }
      }
      let newInput = {
        id: Math.random().toString(16).slice(2),
        type: "text",
        content: "",
        showPlus: true,
        popupOpen: false,
      };
      sections.splice(index + 1, 0, newInput);
      this.setState(
        {
          sections: sections,
          editting: newInput.id,
        },
        () => {
          document.getElementById(newInput.id).focus();
          this.saveProgress();
        }
      );
    } else {
      document.getElementById(`${id}-2`).style.border = "1px solid red";
      document.getElementById(`${id}-3`).style.border = "1px solid red";
    }
  };
  cancelAffiliateLink = (id) => {
    let sections = this.state.sections;
    for (let i = 0; i < sections.length; i++) {
      if (sections[i].id === id) {
        sections[i].type = "text";
        sections[i].content = "";
        sections[i].popupOpen = false;
        sections[i].showPlus = true;
      }
    }
    this.setState(
      {
        sections: sections,
      },
      () => {
        document.getElementById(id).focus();
      }
    );
  };
  setSectionVideo = (e, id) => {
    if (e.key === "Enter") {
      e.preventDefault();
      let sections = this.state.sections;
      let index;
      for (let i = 0; i < sections.length; i++) {
        if (sections[i].id === id) {
          index = i;
          sections[i].type = "video";
          sections[i].content = e.target.value.replace("watch?v=", "embed/");
          sections[i].popupOpen = false;
          sections[i].showPlus = false;
        }
      }
      let newInput = {
        id: Math.random().toString(16).slice(2),
        type: "text",
        content: "",
        showPlus: true,
        popupOpen: false,
      };
      sections.splice(index + 1, 0, newInput);
      this.setState(
        {
          sections: sections,
          editting: newInput.id,
        },
        () => {
          document.getElementById(newInput.id).focus();
        }
      );
    }
  };

  removeAddVideo = (e, id) => {
    if (e.key === "Backspace" || e.key === "Delete") {
      let start = document.getElementById(e.target.id).selectionStart;
      let end = document.getElementById(e.target.id).selectionEnd;
      //let oldLength;
      if (start === 0 && start === end) {
        let sections = this.state.sections;
        for (let i = 0; i < sections.length; i++) {
          if (sections[i].id === id) {
            sections[i].type = "text";
            sections[i].content = "";
            sections[i].popupOpen = false;
            sections[i].showPlus = true;
          }
        }
        this.setState(
          {
            sections: sections,
          },
          () => {
            document.getElementById(id).focus();
          }
        );
      }
    }
  };
  removeAddPhoto = (e, id) => {
    if (e.key === "Backspace" || e.key === "Delete") {
      let start = document.getElementById(e.target.id).selectionStart;
      let end = document.getElementById(e.target.id).selectionEnd;
      //let oldLength;
      if (start === 0 && start === end) {
        let sections = this.state.sections;
        for (let i = 0; i < sections.length; i++) {
          if (sections[i].id === id) {
            sections[i].type = "text";
            sections[i].content = "";
            sections[i].popupOpen = false;
            sections[i].showPlus = true;
          }
        }
        this.setState(
          {
            sections: sections,
          },
          () => {
            document.getElementById(id).focus();
          }
        );
      }
    }
  };
  setSectionEllipse = (id) => {
    let sections = this.state.sections;
    let sectionPosition;
    let index;
    for (let i = 0; i < sections.length; i++) {
      if (sections[i].id === id) {
        index = i;
        sections[i].type = "ellipse";
        sections[i].popupOpen = false;
        sections[i].showPlus = false;
      }
    }
    let newInput = {
      id: Math.random().toString(16).slice(2),
      type: "text",
      content: "",
      showPlus: true,
      popupOpen: false,
    };
    sections.splice(index + 1, 0, newInput);
    this.setState(
      {
        sections: sections,
        editting: newInput.id,
      },
      () => {
        document.getElementById(newInput.id).focus();
      }
    );
  };
  setSectionQuiz = (id) => {
    let sections = this.state.sections;
    let sectionPosition;
    let index;
    for (let i = 0; i < sections.length; i++) {
      if (sections[i].id === id) {
        index = i;
        sections[i].type = "quiz";
        sections[i].content = [
          {
            questionId: Math.random().toString(16).slice(2),
            imageUrl: "",
            question: "",
            answer: "",
            guess1: {
              id: Math.random().toString(16).slice(2),
              guessString: "",
            },
            guess2: {
              id: Math.random().toString(16).slice(2),
              guessString: "",
            },
            guess3: {
              id: Math.random().toString(16).slice(2),
              guessString: "",
            },
            guess4: {
              id: Math.random().toString(16).slice(2),
              guessString: "",
            },
          },
        ];
        sections[i].popupOpen = false;
        sections[i].showPlus = false;
      }
    }
    let newInput = {
      id: Math.random().toString(16).slice(2),
      type: "text",
      content: "",
      showPlus: true,
      popupOpen: false,
    };
    sections.splice(index + 1, 0, newInput);
    this.setState({
      sections: sections,
      editting: id,
    });
  };
  editExistingQuiz = (id) => {
    this.setState({ editting: id });
  };
  chooseAnswer = (id, questionId, answerId) => {
    console.log(answerId);
    let sections = this.state.sections;
    for (let i = 0; i < sections.length; i++) {
      if (sections[i].id === id) {
        for (let j = 0; j < sections[i].content.length; j++) {
          if (sections[i].content[j].questionId === questionId) {
            sections[i].content[j].answer = answerId;
          }
        }
      }
    }
    this.setState(
      {
        sections: sections,
      },
      () => {
        this.saveProgress();
      }
    );
  };
  addQuestion = (id) => {
    let sections = this.state.sections;
    for (let i = 0; i < sections.length; i++) {
      if (sections[i].id === id) {
        sections[i].content.push({
          questionId: Math.random().toString(16).slice(2),
          imageUrl: "",
          question: "",
          answer: "",
          guess1: {
            id: Math.random().toString(16).slice(2),
            guessString: "",
          },
          guess2: {
            id: Math.random().toString(16).slice(2),
            guessString: "",
          },
          guess3: {
            id: Math.random().toString(16).slice(2),
            guessString: "",
          },
          guess4: {
            id: Math.random().toString(16).slice(2),
            guessString: "",
          },
        });
      }
    }
    this.setState(
      {
        sections: sections,
      },
      () => {
        this.saveProgress();
      }
    );
  };
  editQuestion = (id, questionId, theKey, theValue) => {
    let sections = this.state.sections;
    for (let i = 0; i < sections.length; i++) {
      if (sections[i].id === id) {
        for (let j = 0; j < sections[i].content.length; j++) {
          if (sections[i].content[j].questionId === questionId) {
            sections[i].content[j][theKey] = theValue;
          }
        }
      }
    }
    this.setState({
      sections: sections,
    });
  };
  removeQuestion = (id, questionId) => {
    let sections = this.state.sections;
    for (let i = 0; i < sections.length; i++) {
      if (sections[i].id === id) {
        for (let j = 0; j < sections[i].content.length; j++) {
          if (sections[i].content[j].questionId === questionId) {
            sections[i].content.splice(j, 1);
          }
        }
      }
    }
    this.setState(
      {
        sections: sections,
      },
      () => {
        this.saveProgress();
      }
    );
  };
  editAnswer = (id, questionId, theKey, theValue) => {
    let sections = this.state.sections;
    for (let i = 0; i < sections.length; i++) {
      if (sections[i].id === id) {
        for (let j = 0; j < sections[i].content.length; j++) {
          if (sections[i].content[j].questionId === questionId) {
            let specificAnswer = sections[i].content[j][theKey];
            specificAnswer.guessString = theValue;
          }
        }
      }
    }
    this.setState({
      sections: sections,
    });
  };
  deleteQuiz = (id) => {
    let sections = this.state.sections;
    for (let i = 0; i < sections.length; i++) {
      if (sections[i].id === id) {
        sections[i].type = "text";
        sections[i].content = "";
        sections[i].popupOpen = false;
        sections[i].showPlus = true;
      }
    }
    this.setState(
      {
        sections: sections,
      },
      () => {
        document.getElementById(id).focus();
        this.saveProgress();
      }
    );
  };
  chooseAPhoto = (id, url, links) => {
    let sections = this.state.sections;
    let newInput;
    for (let i = 0; i < sections.length; i++) {
      if (sections[i].id === id) {
        sections[i].content = url;
        sections[i].links = links;
        if (i === sections.length - 1) {
          newInput = {
            id: Math.random().toString(16).slice(2),
            type: "text",
            content: "",
            showPlus: true,
            popupOpen: false,
          };
          sections.push(newInput);
        }
      }
    }
    if (newInput) {
      this.setState(
        {
          sections: sections,
          editting: newInput.id,
        },
        () => {
          document.getElementById(newInput.id).focus();
        }
      );
    }
  };
  setTheAlt = (id, text) => {
    let allSections = this.state.sections;
    for (let i = 0; i < allSections.length; i++) {
      if (allSections[i].id === id) {
        allSections[i].alt = text;
      }
    }
    this.setState({ sections: allSections });
  };
  setTheDescription = (id, text) => {
    let allSections = this.state.sections;
    for (let i = 0; i < allSections.length; i++) {
      if (allSections[i].id === id) {
        allSections[i].description = text;
      }
    }
    this.setState({ sections: allSections });
  };
  deletePhoto = (id) => {
    let sections = this.state.sections;
    for (let i = 0; i < sections.length; i++) {
      if (sections[i].id === id) {
        sections.splice(i, 1);
        this.setState({
          sections: sections,
        });
      }
    }
  };
  setFocus = (section) => {
    let currentId = this.state.editting;
    let theSections = this.state.sections;
    for (let i = 0; i < theSections.length; i++) {
      if (theSections[i].id === currentId) {
        theSections[i].showPlus = false;
      }
    }
    this.setState(
      {
        editting: section,
        sections: theSections,
      },
      () => {
        let el = document.getElementById(section);
        el.focus();
        this.textAreaAdjust(el);
        this.setCaretPosition(section, el.value.length);
      }
    );
  };
  emptyBoxPrep = (id) => {
    let sections = this.state.sections;
    for (let i = 0; i < sections.length; i++) {
      if (sections[i].id === id) {
        sections[i].showPlus = true;
      }
    }
    this.setState({
      sections: sections,
      editting: id,
    });
  };
  nowTheLink = (id) => {
    if (this.state.addLink !== false) {
      this.setState({
        addLink: false,
      });
    } else {
      this.setState({
        addLink: id,
      });
    }
  };
  setArticleImage = () => {
    let theImage = this.state.articleImage;
    for (let i = 0; i < this.state.sections.length; i++) {
      if (this.state.sections[i].type === "image") {
        theImage = this.state.sections[i].content;
        break;
      }
    }
    return theImage;
  };
  submitTheBlog = () => {
    let sections = this.state.sections;
    sections.forEach((element) => {
      delete element.showPlus;
      delete element.popupOpen;
    });

    let theImage = this.setArticleImage();

    this.setState({
      saving: true,
      saved: false,
    });
    let punctuationless = this.state.googleTitle.replace(
      /[.,\/#!?$%\^&\*;:{}=|\-_'`~()]/g,
      ""
    );
    let finalString = punctuationless.replace(/\s{2,}/g, " ");
    let preppedUrl = finalString.replace(/ /g, "-").toLowerCase();

    let myToken = localStorage.getItem("token");
    let myHeader = {
      headers: { Authorization: `Bearer ${myToken}` },
    };
    console.log("submitiion tried");
    console.log(this.props.reviewing.Status);
    Axios.put(
      `${baseUrl}/submitblog`,
      {
        Id: this.state.id,
        Author: this.state.author,
        AuthorImageUrl: this.state.authorImageUrl,
        Date: new Date(),
        GoogleTitle: this.state.googleTitle,
        Url: preppedUrl,
        ArticleImage: theImage,
        Title: sections[0].content,
        GoogleMeta: this.state.googleMeta,
        Sections: sections,
        WordCount: this.state.wordCount,
        Category: this.state.category,
        Canonical: this.state.canonical,
        CanonicalUrl: this.state.canonicalUrl,
        Status: this.props.reviewing ? "published" : "submitted",
        School: this.state.school,
      },
      myHeader
    )
      .then((res) => {
        console.log(res.data);
        this.setState({
          saving: false,
          saved: false,
          submitted: true,
        });
        this.props.setCurrentView("mydrafts");
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          saving: false,
          saved: false,
        });
      });
  };
  toggleBlogDelete = () => {
    this.setState((prevState) => {
      return {
        areyousure: !prevState.areyousure,
      };
    });
  };
  deleteTheBlog = () => {
    document.getElementById("are-you-sure-box").style.animation =
      "boxSpin 1s 5";
    let myToken = localStorage.getItem("token");
    let myHeader = {
      headers: { Authorization: `Bearer ${myToken}` },
    };
    Axios.delete(`${baseUrl}/submitblog/${this.state.id}`, myHeader)
      .then((res) => {
        this.setState({
          areyousure: false,
        });
        this.props.setCurrentView("mydrafts");
      })
      .catch((err) => {
        this.setState({
          areyousure: false,
        });
        console.log(err);
      });
  };
  saveProgress = () => {
    this.setState({
      saving: true,
      saved: false,
    });

    let punctuationless = this.state.googleTitle.replace(
      /[.,\/#!?$%\^&\*;:{}=|\-_'`~()]/g,
      ""
    );
    let finalString = punctuationless.replace(/\s{2,}/g, " ");
    let theUrl = finalString.replace(/ /g, "-").toLowerCase();

    let theImage = this.setArticleImage();
    let sections = this.state.sections;
    let myToken = localStorage.getItem("token");
    let myHeader = {
      headers: { Authorization: `Bearer ${myToken}` },
    };
    Axios.put(
      `${baseUrl}/savingblog`,
      {
        Id: this.state.id,
        Title: this.state.sections[0].content,
        Date: this.state.date,
        WordCount: this.state.wordCount,
        Author: this.state.author,
        AuthorImageUrl: this.state.authorImageUrl,
        ArticleImage: theImage,
        GoogleTitle: this.state.googleTitle,
        Url: theUrl,
        GoogleMeta: this.state.googleMeta,
        Sections: sections,
        Category: this.state.category,
        Canonical: this.state.canonical,
        CanonicalUrl: this.state.canonicalUrl,
        School: this.state.school,
      },
      myHeader
    )
      .then(() => {
        this.setState({
          saving: false,
          saved: true,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          saving: false,
          saved: false,
        });
      });
  };
  googleTitleChange = (e) => {
    if (e.target.id === "google-inputs") {
      this.setState({ googleTitle: e.target.value });
    }
    // else if (e.target.id === "google-meta") {
    //     this.setState({
    //         googleMeta: e.target.value,
    //         metaLength: 160 - e.target.value.length
    //     })
    // }
  };
  changeTheSchool = (school) => {
    this.setState(
      {
        school: school,
      },
      this.saveProgress()
    );
  };
  googleMetaChange = (e) => {
    this.setState({
      googleMeta: e.target.value,
      metaLength: 160 - e.target.value.length,
    });
  };
  uploadThePhoto = (e, id) => {
    e.preventDefault();
    //setLoading(true)
    const imageFile = document.getElementById("the-camera-image").files[0];
    let formData = new FormData();
    formData.append("teacherImage", imageFile);
    const theName = imageFile.name;
    if (imageFile.size < 300000) {
      //props.setImageName(imageFile.name)
      Axios.post(`${baseUrl}/imageupload`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          if (response.status === 200) {
            let sections = this.state.sections;
            //setLoading(false)
            //props.toggleUploadModal()
            let path = URL.createObjectURL(imageFile);
            let index;
            for (let i = 0; i < sections.length; i++) {
              if (sections[i].id === id) {
                index = i;
                sections[i].type = "image";
                sections[i].content = `https://app.atharo.app/images/${theName
                  .replace(/ /g, "-")
                  .toLowerCase()}`;
                sections[i].showPlus = false;
                sections[i].popupOpen = false;
              }
            }
            let afterpic = {
              id: Math.random().toString(16).slice(2),
              type: "text",
              content: "",
              showPlus: true,
              popupOpen: false,
            };
            sections.splice(index + 1, 0, afterpic);
            this.setState({ sections: sections, editting: afterpic.id }, () => {
              document.getElementById(afterpic.id).focus();
            });
            //props.setImg(path)
          } else {
            //setLoading(false)
          }
        })
        .catch((err) => {
          //setLoading(false)
          this.setState({ error: true });
          alert(err);
        });
    } else {
      alert("Image too big!");
      //setLoading(false)
    }
  };
  closeError = () => {
    this.setState({ error: false });
  };
  changeTheCategory = (value) => {
    this.setState(
      {
        category: value,
      },
      () => {
        this.saveProgress();
      }
    );
  };
  changeTheCanonical = (value) => {
    this.setState(
      {
        canonical: value,
      },
      () => {
        this.saveProgress();
      }
    );
  };
  changeTheAuthorImage = (value) => {
    this.setState(
      {
        authorImageUrl: value,
      },
      () => {
        this.checkHighlight();
      }
    );
  };
  changeCanonicalUrl = (value) => {
    this.setState(
      {
        canonicalUrl: value,
      },
      () => {
        this.checkHighlight();
      }
    );
  };
  changeTheAuthorName = (value) => {
    this.setState({ author: value });
  };
  render() {
    return this.state.loading ? (
      <div className="w-full flex items-center justify-center pt-24">
        Loading blog...
      </div>
    ) : (
      <div className="whole-blog-creator">
        {this.state.areyousure && (
          <div className="are-you-sure-wrapper">
            <div className="are-you-sure-box" id="are-you-sure-box">
              <p>Do you want to delete this blog?</p>
              <div className="are-you-sure-btn-wrapper">
                <div
                  className="are-you-sure-btns"
                  onClick={() => this.deleteTheBlog()}
                >
                  Yes
                </div>
                <div
                  className="are-you-sure-btns"
                  onClick={() => this.toggleBlogDelete()}
                >
                  No
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="writing-blog-header">
          <div className="blog-username-area">
            Draft for{" "}
            <input
              value={this.state.author}
              onChange={(e) => this.changeTheAuthorName(e.target.value)}
            />
            {this.state.saved && <p className="blog-saved">Saved</p>}
            {this.state.saving && <p className="blog-saved">Saving</p>}
            {this.state.submitted && (
              <p className="blog-saved blog-submitted">Submitted!</p>
            )}
          </div>
          <div className="word-counter" id="word-counter">
            Word Count: {this.state.wordCount}
          </div>
          {this.props.userData.School === "admin" && (
            <div className="blog-school-selector-wrapper">
              <select
                className="school-selector"
                value={this.state.school}
                onChange={(e) => this.changeTheSchool(e.target.value)}
              >
                <option value="admin">Choose a school</option>
                <option value="mma">Mountainside</option>
                <option value="lsma">Lakeside</option>
                <option value="tma">Treeside</option>
                <option value="mor">Morningside</option>
                <option value="psma">Parkside</option>
                <option value="atharo-music">Atharo Music</option>
              </select>
            </div>
          )}
          <div className="publish-btn" onClick={() => this.submitTheBlog()}>
            Submit
          </div>
          <div className="delete-btn" onClick={() => this.toggleBlogDelete()}>
            Delete
          </div>
        </div>
        <div className="author-details-and-category-wrapper">
          {this.state.author !== "Adrienne O'Brien" && (
            <div className="author-details-box">
              <div className="author-details-box__section">
                <div className="author-picture-link-label">
                  Author Picture Link:
                </div>
                <input
                  value={this.state.authorImageUrl}
                  onChange={(e) => this.changeTheAuthorImage(e.target.value)}
                  className="author-picture-link"
                />
              </div>
            </div>
          )}
          <div className="selectors-wrapper">
            <select
              className="category-selector"
              value={this.state.category}
              onChange={(e) => this.changeTheCategory(e.target.value)}
            >
              <option value="body">Body</option>
              <option value="mind">Mind</option>
              <option value="self-growth">Self-Growth</option>
              <option value="nourishment">Nourishment</option>
              <option value="recipe">Recipe</option>
            </select>
            <select
              className="category-selector"
              value={this.state.canonical}
              onChange={(e) => this.changeTheCanonical(e.target.value)}
            >
              <option value={false}>Original</option>
              <option value={true}>Syndicated</option>
            </select>
            <input
              className="canonical-url-input"
              value={this.state.canonicalUrl}
              placeholder="Enter Original URL for Article"
              onChange={(e) => this.changeCanonicalUrl(e.target.value)}
            />
          </div>
        </div>
        <div className="google-section">
          <input
            className="google-inputs"
            id="google-inputs"
            onChange={(e) => this.googleTitleChange(e)}
            value={this.state.googleTitle}
            placeholder="Google Title"
          />
          <h3 className="meta-length-number">{this.state.metaLength}</h3>
          <textarea
            className="google-meta"
            id="google-meta"
            onChange={(e) => this.googleMetaChange(e)}
            value={this.state.googleMeta}
            placeholder="Google Meta-Tag (<160 Characters)"
          />
        </div>
        <div className="blog-title-wrapper">
          {this.state.sections[0] && (
            <input
              type="text"
              placeholder="Blog Title"
              id="blog-title"
              className="blog-title"
              onKeyUp={(e) => this.handleKeyPress(e)}
              value={this.state.sections[0].content}
              onChange={(e) => this.handleChange(e, e.target.id)}
            />
          )}
        </div>
        {this.state.highlight && (
          <StyleSelector
            sections={this.state.sections}
            start={this.state.popupMarginLeft}
            top={this.state.popupMarginTop}
            sectionId={this.state.theField}
            insertAtCursor={this.insertAtCursor}
            nowTheLink={this.nowTheLink}
          />
        )}
        {this.state.addLink && (
          <LinkPopUp
            start={this.state.popupMarginLeft}
            top={this.state.popupMarginTop}
            addTheLink={this.addTheLink}
          />
        )}
        {this.state.sections.map((section) => (
          <div className="blog-input-wrapper" key={section.id}>
            {section.showPlus && (
              <div
                className="blog-plus-sign"
                id={`plus-${section.id}`}
                onClick={() => this.togglePopup(section.id)}
              ></div>
            )}
            {section.popupOpen && (
              <TypePopUp
                setSectionPhoto={this.setSectionPhoto}
                id={section.id}
                setSectionEllipse={this.setSectionEllipse}
                setSectionMusic={this.setSectionMusic}
                setSectionAddVideo={this.setSectionAddVideo}
                setSectionQuiz={this.setSectionQuiz}
              />
            )}
            {section.type === "text" && section.id !== this.state.editting && (
              <div
                onClick={() => {
                  this.setFocus(section.id);
                }}
              >
                <div className="was-react-markdown also-react-markdown">
                  {section.content}
                </div>
              </div>
            )}
            {section.type === "pullQuote1" &&
              section.id !== this.state.editting && (
                <div
                  onClick={() => {
                    this.setFocus(section.id);
                  }}
                >
                  <div className="pull-quote-1">{section.content}</div>
                </div>
              )}
            {section.type === "pullQuote2" &&
              section.id !== this.state.editting && (
                <div
                  onClick={() => {
                    this.setFocus(section.id);
                  }}
                >
                  <div className="pull-quote-2 also-react-markdown">
                    {section.content}
                  </div>
                </div>
              )}
            {section.type === "pullQuote3" &&
              section.id !== this.state.editting && (
                <div
                  onClick={() => {
                    this.setFocus(section.id);
                  }}
                >
                  <div className="pull-quote-3 also-react-markdown">
                    {section.content}
                  </div>
                </div>
              )}
            {section.type === "text" &&
              section.id !== this.state.editting &&
              section.content === "" && (
                <textarea
                  key={section.id}
                  className="blog-input"
                  id={section.id}
                  value={section.content}
                  onChange={(e) => this.handleChange(e, section.id)}
                  onKeyDown={this.deleteFunc}
                  onKeyUp={(e) => this.handleKeyPress(e)}
                  onClick={(e) => this.emptyBoxPrep(e.target.id)}
                />
              )}
            {section.type === "quiz" && section.id !== this.state.editting && (
              <div
                className="edit-quiz__placeholder"
                onClick={() => this.editExistingQuiz(section.id)}
              >
                Edit Quiz
              </div>
            )}

            {section.type === "text" && section.id === this.state.editting && (
              <textarea
                key={section.id}
                className="blog-input"
                id={section.id}
                value={section.content}
                onChange={(e) => this.handleChange(e, section.id)}
                onKeyDown={this.deleteFunc}
                onKeyUp={(e) => this.handleKeyPress(e)}
              />
            )}
            {section.type === "pullQuote1" &&
              section.id === this.state.editting && (
                <textarea
                  key={section.id}
                  className="blog-input pull-quote-1"
                  id={section.id}
                  value={section.content}
                  onChange={(e) => this.handleChange(e, section.id)}
                  onKeyDown={this.deleteFunc}
                  onKeyUp={(e) => this.handleKeyPress(e)}
                  onFocus={(e) => this.handleChange(e, section.id)}
                />
              )}
            {section.type === "pullQuote2" &&
              section.id === this.state.editting && (
                <textarea
                  key={section.id}
                  className="blog-input pull-quote-2"
                  id={section.id}
                  value={section.content}
                  onChange={(e) => this.handleChange(e, section.id)}
                  onKeyDown={this.deleteFunc}
                  onKeyUp={(e) => this.handleKeyPress(e)}
                  onFocus={(e) => this.handleChange(e, section.id)}
                />
              )}
            {section.type === "pullQuote3" &&
              section.id === this.state.editting && (
                <textarea
                  key={section.id}
                  className="blog-input pull-quote-3"
                  id={section.id}
                  value={section.content}
                  onChange={(e) => this.handleChange(e, section.id)}
                  onKeyDown={this.deleteFunc}
                  onKeyUp={(e) => this.handleKeyPress(e)}
                  onFocus={(e) => this.handleChange(e, section.id)}
                />
              )}
            {section.type === "image" && (
              <PhotoSection
                sectionId={section.id}
                selectedPhoto={section.content}
                links={section.links}
                chooseAPhoto={this.chooseAPhoto}
                deletePhoto={this.deletePhoto}
              />
            )}
            {section.type === "ellipse" && (
              <div className="whole-ellipse">...</div>
            )}
            {section.type === "addVideo" &&
              section.id === this.state.editting && (
                <textarea
                  id={section.id}
                  className="blog-input the-video"
                  placeholder="Paste a YouTube, Vimeo, or other video link, and press Enter"
                  onKeyUp={(e) => this.setSectionVideo(e, section.id)}
                  onKeyDown={(e) => this.removeAddVideo(e, section.id)}
                />
              )}
            {section.type === "video" && (
              <div id={section.id} className="video-preview">
                <iframe
                  src={section.content}
                  frameBorder="0"
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                  title="video"
                />
              </div>
            )}
            {section.type === "quiz" && section.id === this.state.editting && (
              <QuizModule
                section={section}
                deleteQuiz={() => this.deleteQuiz(section.id)}
                chooseAnswer={this.chooseAnswer}
                editQuestion={this.editQuestion}
                editAnswer={this.editAnswer}
                addQuestion={this.addQuestion}
                removeQuestion={this.removeQuestion}
              />
            )}
            {section.type === "addAffiliate" &&
              section.id === this.state.editting && (
                <div>
                  <h3
                    className="affiliate-close-x"
                    onClick={() => this.cancelAffiliateLink(section.id)}
                  >
                    X
                  </h3>
                  <textarea
                    id={`${section.id}-1`}
                    className="blog-input the-src-code"
                    placeholder="Paste code here"
                  />
                  <textarea
                    id={`${section.id}-2`}
                    className="blog-input the-src"
                    placeholder="Enter Width #"
                  />
                  <textarea
                    id={`${section.id}-3`}
                    className="blog-input the-src"
                    placeholder="Enter Height #"
                  />
                  <div
                    className="submit-affiliate-link-btn"
                    onClick={() => this.submitAffiliateLink(section.id)}
                  >
                    Submit Link
                  </div>
                </div>
              )}
            {section.type === "affiliate" && (
              <div
                id={section.id}
                style={{
                  height: `${section.height}px`,
                  width: `${section.width}px`,
                }}
                className="affiliate-link-preview"
              >
                <div
                  className="my-ads"
                  style={{
                    height: `${section.height}`,
                    width: `${section.width}`,
                  }}
                  dangerouslySetInnerHTML={{ __html: section.content }}
                />
              </div>
            )}
            {/* THIS WAS AN EMERGENCY ADDITION IT SHOULD BE REFORMED */}
            {section.type === "sheet-music" && (
              <img className="selected-image" src={section.content} />
            )}
            {/* ----------------------------------------------------------- */}
          </div>
        ))}
        <div className="bottom-bumper"></div>
      </div>
    );
  }
}

export default BlogCreator;
